import i18n from '@/i18n';
import loadable from '@loadable/component';
//$IMPORT$

export default () => [
  {
    needLogin: true,
    resourceName: i18n.t('Promotion-index-1992f2b8a8cbe086b-1'),
    routerUrl: '/Promotion',
    resourceIcon: 'TeamOutlined',
    type: '0',
    buttons: [],
    noparent: true,
    component: loadable(() => import('./Promotion')),
    children: [
      {
        needLogin: true,
        resourceName: i18n.t('Promotion-index-1992f2b8a8cbe086b-2'),
        routerUrl: '/PromotionForm',
        resourceIcon: '',
        type: '2',
        buttons: [],
        component: loadable(() => import('./PromotionForm')),
      },
      //$MORE$
    ],
  },
];
